import type { Component } from 'vue';
import UtuaShell from './utua/Shell.vue';
import UtuaQuestion from './utua/Question.vue';
import UtuaGate from './utua/Gate.vue';
import SliderShell from './slider/Shell.vue';
import SliderQuestionGate from './slider/QuestionGate.vue';
import UnumShell from './unum/Shell.vue';
import UnumQuestion from './unum/Question.vue';
import UnumGate from './unum/Gate.vue';
import PluzetixShell from './pluzetix/Shell.vue';
import PluzetixQuestion from './pluzetix/Question.vue';
import PluzetixGate from './pluzetix/Gate.vue';
import TrouverfinanShell from './trouverfinan/Shell.vue';
import TrouverfinanQuestion from './trouverfinan/Question.vue';
import TrouverfinanGate from './trouverfinan/Gate.vue';
import HitschkyShell from './hitschky/Shell.vue';
import HitschkyQuestion from './hitschky/Question.vue';
import HitschkyGate from './hitschky/Gate.vue';
import WasdShell from './wasd/Shell.vue';
import WasdQuestion from './wasd/Question.vue';
import WasdGate from './wasd/Gate.vue';
import GreenfozShell from './greenfoz/Shell.vue';
import GreenfozQuestion from './greenfoz/Question.vue';
import GreenfozGate from './greenfoz/Gate.vue';
import ZaplinoShell from './zaplino/Shell.vue';
import ZaplinoQuestion from './zaplino/Question.vue';
import ZaplinoGate from './zaplino/Gate.vue';
import ZarroShell from './zarro/Shell.vue';
import ZarroQuestion from './zarro/Question.vue';
import ZarroGate from './zarro/Gate.vue';
import MiportalShell from './miportal/Shell.vue';
import MiportalFormGate from './miportal/FormGate.vue';
import WasditShell from './wasdit/Shell.vue';
import WasditQuestion from './wasdit/Question.vue';
import WasditGate from './wasdit/Gate.vue';
import InfontcShell from './infontc/Shell.vue';
import InfontcQuestion from './infontc/Question.vue';
import InfontcGate from './infontc/Gate.vue';
import SnkowsShell from './snkows/Shell.vue';
import SnkowsQuestion from './snkows/Question.vue';
import SnkowsGate from './snkows/Gate.vue';
import DadecorShell from './dadecor/Shell.vue';
import DadecorQuestion from './dadecor/Question.vue';
import DadecorGate from './dadecor/Gate.vue';
import PowersdtShell from './powersdt/Shell.vue';
import PowersdtQuestion from './powersdt/Question.vue';
import PowersdtGate from './powersdt/Gate.vue';
import MoneyfocusShell from './moneyfocus/Shell.vue';
import MoneyfocusQuestion from './moneyfocus/Question.vue';
import MoneyfocusGate from './moneyfocus/Gate.vue';
import MinimalguyShell from './minimalguy/Shell.vue';
import MinimalguyQuestion from './minimalguy/Question.vue';
import MinimalguyGate from './minimalguy/Gate.vue';
import BomcotarShell from './bomcotar/Shell.vue';
import BomcotarQuestion from './bomcotar/Question.vue';
import BomcotarGate from './bomcotar/Gate.vue';
import './utua/styles.css';
import './slider/styles.css';
import './unum/styles.css';
import './pluzetix/styles.css';
import './trouverfinan/styles.css';
import './hitschky/styles.css';
import './wasd/styles.css';
import './greenfoz/styles.css';
import './zaplino/styles.css';
import './zarro/styles.css';
import './miportal/styles.css';
import './wasdit/styles.css';
import './infontc/styles.css';
import './snkows/styles.css';
import './dadecor/styles.css';
import './powersdt/styles.css';
import './moneyfocus/styles.css';
import './minimalguy/styles.css';
import './bomcotar/styles.css';

/**
 * Template registry (DEV-1135). A template contributes PRESENTATION ONLY:
 * a page shell (logo/hero/progress/footer chrome) plus per-block markup
 * overrides for the question and gate screens. All logic — analytics, lead
 * submission, navigation, redirects — lives in the core blocks
 * (src/flow/blocks) and composables; template SFCs are restricted to a single
 * `defineProps` call (enforced by the template-purity contract test).
 *
 * Templates are EAGER-bundled (D19): at the current registry size the bytes
 * are negligible and an async chunk would add a round-trip on the quiz
 * critical path. Revisit code-splitting when the registry exceeds 3 templates
 * or ~30KB gz aggregate.
 *
 * The `default` template is NOT in this registry — quizzes without
 * flow/template fields render through the untouched legacy path.
 */
export interface TemplateDefinition {
  id: string;
  shell: Component;
  question?: Component;
  gate?: Component;
  // Combined single-page mechanic (question-gate screens, slider funnels).
  questionGate?: Component;
  // Multi-question single-page form (form-gate screens, select-form funnels).
  formGate?: Component;
}

const templates: Record<string, TemplateDefinition> = {
  utua: {
    id: 'utua',
    shell: UtuaShell,
    question: UtuaQuestion,
    gate: UtuaGate,
  },
  slider: {
    id: 'slider',
    shell: SliderShell,
    questionGate: SliderQuestionGate,
  },
  unum: {
    id: 'unum',
    shell: UnumShell,
    question: UnumQuestion,
    gate: UnumGate,
  },
  pluzetix: {
    id: 'pluzetix',
    shell: PluzetixShell,
    question: PluzetixQuestion,
    gate: PluzetixGate,
  },
  trouverfinan: {
    id: 'trouverfinan',
    shell: TrouverfinanShell,
    question: TrouverfinanQuestion,
    gate: TrouverfinanGate,
  },
  hitschky: {
    id: 'hitschky',
    shell: HitschkyShell,
    question: HitschkyQuestion,
    gate: HitschkyGate,
  },
  wasd: {
    id: 'wasd',
    shell: WasdShell,
    question: WasdQuestion,
    gate: WasdGate,
  },
  greenfoz: {
    id: 'greenfoz',
    shell: GreenfozShell,
    question: GreenfozQuestion,
    gate: GreenfozGate,
  },
  zaplino: {
    id: 'zaplino',
    shell: ZaplinoShell,
    question: ZaplinoQuestion,
    gate: ZaplinoGate,
  },
  zarro: {
    id: 'zarro',
    shell: ZarroShell,
    question: ZarroQuestion,
    gate: ZarroGate,
  },
  miportal: {
    id: 'miportal',
    shell: MiportalShell,
    formGate: MiportalFormGate,
  },
  wasdit: {
    id: 'wasdit',
    shell: WasditShell,
    question: WasditQuestion,
    gate: WasditGate,
  },
  infontc: {
    id: 'infontc',
    shell: InfontcShell,
    question: InfontcQuestion,
    gate: InfontcGate,
  },
  snkows: {
    id: 'snkows',
    shell: SnkowsShell,
    question: SnkowsQuestion,
    gate: SnkowsGate,
  },
  dadecor: {
    id: 'dadecor',
    shell: DadecorShell,
    question: DadecorQuestion,
    gate: DadecorGate,
  },
  powersdt: {
    id: 'powersdt',
    shell: PowersdtShell,
    question: PowersdtQuestion,
    gate: PowersdtGate,
  },
  moneyfocus: {
    id: 'moneyfocus',
    shell: MoneyfocusShell,
    question: MoneyfocusQuestion,
    gate: MoneyfocusGate,
  },
  minimalguy: {
    id: 'minimalguy',
    shell: MinimalguyShell,
    question: MinimalguyQuestion,
    gate: MinimalguyGate,
  },
  bomcotar: {
    id: 'bomcotar',
    shell: BomcotarShell,
    question: BomcotarQuestion,
    gate: BomcotarGate,
  },
};

export function hasTemplate(id: string): boolean {
  return Object.prototype.hasOwnProperty.call(templates, id);
}

export function getTemplate(id: string): TemplateDefinition | undefined {
  return templates[id];
}

export function listTemplateIds(): string[] {
  return Object.keys(templates);
}
